import React from 'react';
import { motion } from 'framer-motion';

const HowItWorks = () => {
  const features = [
    {
      icon: '🔒',
      title: 'Encrypted transfers',
      description: 'All data is securely encrypted and transmitted in real time.'
    },
    {
      icon: '📦',
      title: 'Accurate fulfillment',
      description: 'Buyer details are used only for order tasks like syncing to packing slips and fulfillment platform orders.'
    },
    {
      icon: '⏱',
      title: 'Automatic syncing',
      description: 'Orders and tracking stay perfectly up to date without manual intervention.'
    },
    {
      icon: '🧹',
      title: 'Data cleanup',
      description: 'Sensitive buyer data is never stored long term and is automatically deleted after fulfillment.'
    }
  ];

  return (
    <div id="how-it-works" className="bg-gray-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-4xl font-bold text-gray-900 mb-4"
          >
            How it Works
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-xl text-gray-600 max-w-4xl mx-auto"
          >
            CustomSync securely connects to your Amazon store and extracts buyer-entered customization details and images to your connected fulfillment system — no manual copying or spreadsheets required.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
